import React, {Component} from 'react';
import style from "./layout.module.scss";
import classNames from 'classnames';

export default class Row extends Component {

	render() {
		let props = Object.assign({}, this.props);
		props.className = classNames(style.row, props.className);

		return (
			<div {...props}>
				{this.props.children}
			</div>
		);
	}
}